import { createUseStyles } from 'react-jss';

export const useSelectFieldStyles = createUseStyles({
  emptySelect: {
    color: '#999'
  }
});
